import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのPeopleロゴアイコン
 */
export function ProductLogoSmallPeople({
  size = 20,
  color = '#0070C0',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M12.0929 9.939C11.7346 9.87363 11.6478 9.43322 11.87 9.14457C12.4868 8.3432 12.8535 7.33943 12.8535 6.25C12.8535 5.16057 12.4868 4.1568 11.87 3.35543C11.6478 3.06678 11.7346 2.62637 12.0929 2.561C12.3126 2.52093 12.5389 2.5 12.7702 2.5C14.8413 2.5 16.5202 4.17893 16.5202 6.25C16.5202 8.32107 14.8413 10 12.7702 10C12.5389 10 12.3126 9.97907 12.0929 9.939Z"
        fill={color}
      />
      <path
        d="M16.2028 16.5C15.8177 16.5 15.5613 16.0637 15.5955 15.6801C15.6008 15.6208 15.6035 15.5607 15.6035 15.5V15C15.6035 13.9028 15.2501 12.8881 14.6509 12.0636C14.3685 11.6751 14.6232 11 15.1035 11C17.3127 11 19.1035 12.7909 19.1035 15V15.5C19.1035 16.0523 18.6558 16.5 18.1035 16.5H16.2028Z"
        fill={color}
      />
      <path
        d="M8.27018 10C10.3413 10 12.0202 8.32107 12.0202 6.25C12.0202 4.17893 10.3413 2.5 8.27018 2.5C6.19911 2.5 4.52018 4.17893 4.52018 6.25C4.52018 8.32107 6.19911 10 8.27018 10Z"
        fill={color}
      />
      <path
        d="M5.60352 11C3.39438 11 1.60352 12.7909 1.60352 15V15.5C1.60352 16.0523 2.05123 16.5 2.60352 16.5H13.6035C14.1558 16.5 14.6035 16.0523 14.6035 15.5V15C14.6035 12.7909 12.8127 11 10.6035 11H5.60352Z"
        fill={color}
      />
    </svg>
  );
}
